enum ErrorStatus {
  NotModified = 304,
  BadRequest = 400,
  UnAuthourized = 401,
  Forbidden = 403,
  NotFound = 404,
  MethodNotAllowed = 405,
  Conflict = 409,
  ContentTooLarge = 413,
  URLTooLong = 414,
  ServerError = 500,
  Maintenance = 503,
  GatewayTimeoutError = 504,
  // Exception handled
  HandledUnknownException = 1,
  // Used when exception was not handled
  UnHandledException = 2,
  // Validation errros from service layer
  ServiceValidationError = 3
}

export default ErrorStatus;

export const ErrorStatusNotLoggedToSentry = [ErrorStatus.UnAuthourized, ErrorStatus.NotFound];
